import React from 'react';

import { CompanyType } from 'src/api';
import {
  getRevenueShareInitialValues,
  RevenueShareForm,
  RevenueShareFormValues,
} from 'src/components/revenueShare';
import { usePeoById, usePeoParamId } from 'src/hooks/peo';
import { usePeoRevenueShare } from 'src/hooks/peo/usePeoRevenueShare';
import { useStripeAccount } from 'src/hooks/stripe';
import {
  PrepareRevenueShareDataActionTypes,
  prepareRevenueShareData,
} from 'src/utils/revenueShare';

export const PeosDetailsWallet: React.FC = () => {
  const peoId = usePeoParamId();
  const { peo } = usePeoById(peoId);

  const {
    peoBilling,
    updatePeoRevenueShare,
    deletePeoBilling,
    loading: peoRevenueShareLoading,
  } = usePeoRevenueShare(peoId);

  const { stripeAccountStatus, loading: stripeAccountLoading } = useStripeAccount(
    peo?.stripeAccountId,
  );

  const handleSubmit = React.useCallback(
    async (formValues: RevenueShareFormValues) => {
      try {
        const { revenueShareEnabled, ...formData } = formValues;

        if (revenueShareEnabled) {
          const peoBillingAction = peoBilling?.revenueShareSetting
            ? PrepareRevenueShareDataActionTypes.Update
            : PrepareRevenueShareDataActionTypes.Create;

          const dataToSubmit = prepareRevenueShareData(peoBillingAction, CompanyType.Peo, formData);
          await updatePeoRevenueShare(dataToSubmit);
        } else {
          await deletePeoBilling({ id: peoBilling?.revenueShareSetting?.id });
        }
      } catch (error) {
        console.error(error);
      }
    },
    [deletePeoBilling, peoBilling?.revenueShareSetting, updatePeoRevenueShare],
  );

  return (
    <RevenueShareForm
      companyType={CompanyType.Peo}
      stripeAccountStatus={stripeAccountStatus}
      initialValues={getRevenueShareInitialValues(peoBilling)}
      handleSubmit={handleSubmit}
      loading={stripeAccountLoading || peoRevenueShareLoading}
    />
  );
};
